<template>
    <div class="py-4 container-fluid">
        <div class="row justify-content-center">
            <div class="col-lg-8 col-md-10">
                <div class="card">
                    <div class="card-body p-5 text-center" style="min-height: 400px;">

                        <i class="fas fa-map-marker-slash fa-5x text-warning mb-4"></i>
                        <h1 class="display-1 text-danger font-weight-bolder">404</h1>
                        <h2 class="mb-4 text-dark">Módulo No Encontrado</h2>
                        <p class="lead text-muted">
                            Lo sentimos, no pudimos encontrar la ruta a la que intentas acceder.
                            Verifica la URL o utiliza el botón para volver a un lugar seguro.
                        </p>

                        <div class="mt-5">
                            <router-link to="/dashboard-default" class="btn btn-success btn-lg">
                                <i class="fas fa-home me-2"></i> Volver al Dashboard
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NotFound',
}
</script>

<style scoped>
/* Estilos opcionales para centrar verticalmente o mejorar el aspecto */
.container-fluid {
    min-height: 85vh; /* Asegura que el contenedor ocupe la mayor parte de la pantalla */
    display: flex;
    align-items: center;
}
</style>